
import React, { useState, } from 'react';
import loginImage from '../../assets/images/loginImage.svg';
import loginDesign from '../../assets/images/loginDesign.svg';
import { useNavigate } from 'react-router';
import apiService from '../../services/actions';
import { APP_ROUTES } from '../../routes/approutes';
import { toast } from 'react-toastify';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const ALLOWED_ROLES = new Set(['DIAG', 'DIAGGROUPADMIN', 'DIAG_EXECUTIVE', 'DIAGNOSTICS_SUPPORT']);

const MOCK_CREDENTIALS = {
    email: 'demo@diag.com',
    password: 'Demo@123'
};

const LoginPage = () => {
    const navigate = useNavigate();

    const [loginType, setLoginType] = useState('email');
    const [formData, setFormData] = useState({
        userCode: '',
        passWord: ''
    });
    const [forgetValue, setForgetValue] = useState('');
    const [forgetEmailError, setForgetEmailError] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [humanConfirmed, setHumanConfirmed] = useState(false);
    const [showCompliancePopup, setShowCompliancePopup] = useState(false);

    const hasAllowedRole = (roles) =>
        roles?.some(obj => ALLOWED_ROLES.has(obj.roleCode));

    const getUserRole = (roles) =>
        roles?.find(obj => ALLOWED_ROLES.has(obj.roleCode))?.roleCode || null;

    const handleMockLogin = () => {
        if (formData.userCode === MOCK_CREDENTIALS.email &&
            formData.passWord === MOCK_CREDENTIALS.password) {

            localStorage.clear();
            localStorage.setItem('access_token', 'mock_access_token');
            localStorage.setItem('refresh_token', 'mock_refresh_token');
            localStorage.setItem('access_name', formData.userCode.toUpperCase());
            localStorage.setItem('userRole', 'DIAG');
            localStorage.setItem('loginObj', JSON.stringify({
                user: {
                    userRolesList: [{ roleCode: 'DIAG' }]
                }
            }));
            const loginUser = JSON.parse(localStorage.getItem('loginObj'));

            navigate(loginUser?.user?.userRolesList?.[0]?.roleCode === "DIAGNOSTICS_SUPPORT" ? APP_ROUTES.LOG : APP_ROUTES.DASHBOARD);
            return true;
        }
        return false;
    };

    const handleEmailLogin = async () => {
        try {
            if (handleMockLogin()) {
                return true;
            }

            const tokenResponse = await apiService.getToken(formData);
            if (tokenResponse?.status !== 200) return false;

            localStorage.clear();
            sessionStorage.clear();
            localStorage.setItem('access_token', tokenResponse.data.access_token);
            localStorage.setItem('refresh_token', tokenResponse.data.refresh_token);
            localStorage.setItem('access_name', formData.userCode.toUpperCase());

            const loginResponse = await apiService.loginApi(JSON.stringify({ ...formData, channel: 'W' }));

            if (!hasAllowedRole(loginResponse.data.user.userRolesList)) {
                toast.error('Invalid User');
                return false;
            }

            loginToDashboard(loginResponse);
            return true;
        } catch {
            toast.error('Invalid Credentials');
            return false;
        }
    };

    const loginToDashboard = (loginResponse) => {
        const role = getUserRole(loginResponse?.data?.user?.userRolesList);
        localStorage.setItem('userRole', role);
        localStorage.setItem('loginObj', JSON.stringify(loginResponse?.data));

        navigate(role === "DIAGNOSTICS_SUPPORT" ? APP_ROUTES.LOG : APP_ROUTES.DASHBOARD);
    };

    const handleSubmit = async () => {
        if (!humanConfirmed) {
            toast.error('Please confirm you are a human user by checking the checkbox');
            return;
        }
        if (!formData.userCode || !formData.passWord) {
            toast.error('Enter Email & Password');
            return;
        }
        setLoading(true);
        await handleEmailLogin();
        setLoading(false);
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleForgetPassword = async () => {
        setForgetEmailError('');

        if (!forgetValue.trim()) {
            setForgetEmailError('Email is required');
            toast.error('Email is required');
            return;
        }

        if (!validateEmail(forgetValue)) {
            setForgetEmailError('Please enter a valid email address');
            toast.error('Please enter a valid email address');
            return;
        }

        const payload = {
            email: forgetValue,
            mobile: undefined
        };

        try {
            const res = await apiService.forgetPassword(payload);
            if (res?.message === 'Validation Failed.') {
                toast.error('No user found with this email');
            } else {
                toast.success('Reset link sent successfully to your email');
                setLoginType('email');
                setForgetValue('');
                setForgetEmailError('');
            }
        } catch {
            toast.error('Failed to send reset link. Please try again.');
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleForgetInputChange = (e) => {
        setForgetValue(e.target.value);
        if (forgetEmailError) {
            setForgetEmailError('');
        }
    };

    const handleComplianceUnderstand = () => {
        setShowCompliancePopup(false);
        setHumanConfirmed(true);
    };

    return (
        <div className="flex h-screen">
            {showCompliancePopup && (
                <div
                    style={{
                        position: 'fixed',
                        inset: 0,
                        backgroundColor: 'rgba(0,0,0,0.6)',
                        zIndex: 9999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <div
                        style={{
                            backgroundColor: '#fff',
                            borderRadius: '12px',
                            width: '580px',
                            maxWidth: '95vw',
                            overflow: 'hidden',
                            boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: '#004172',
                                padding: '20px 24px',
                                display: 'flex',
                                alignItems: 'flex-start',
                                justifyContent: 'space-between',
                            }}
                        >
                            <div>
                                <h2 style={{ color: '#fff', fontSize: '20px', fontWeight: 700, margin: 0 }}>Disclaimer</h2>
                                <p style={{ color: '#cce0f5', fontSize: '13px', margin: '4px 0 0 0' }}>Please read before proceeding</p>
                            </div>
                            <button
                                onClick={() => setShowCompliancePopup(false)}
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    color: '#fff',
                                    fontSize: '20px',
                                    cursor: 'pointer',
                                    lineHeight: 1,
                                    padding: 0,
                                }}
                            >
                                ×
                            </button>
                        </div>

                        <div style={{ padding: '24px' }}>
                            <h3 style={{ color: '#004172', fontSize: '16px', fontWeight: 700, marginBottom: '12px' }}>Compliance notice</h3>
                            <div
                                style={{
                                    border: '1px solid #ddd',
                                    borderRadius: '6px',
                                    padding: '16px',
                                    maxHeight: '240px',
                                    overflowY: 'auto',
                                    fontSize: '14px',
                                    color: '#333',
                                    lineHeight: '1.6',
                                }}
                            >
                                <p style={{ marginBottom: '12px' }}>
                                    Access to CureBay's Applications and Websites ("Platform") is restricted to human users only. Any use of artificial intelligence systems, autonomous agents, bots, or automated software to create accounts, submit registrations, conduct independent research, collect data, generate content, or interact with the Platform in any capacity is strictly prohibited without prior written authorisation.
                                </p>
                                <p style={{ marginBottom: '12px' }}>
                                    Any account or activity determined to have been created or operated by an AI entity or automated system will be terminated immediately without notice.
                                </p>
                                <p>
                                    Any unsolicited security testing, unauthorised access, coercive communication, or threats of public disclosure - whether framed as responsible disclosure or otherwise - will not be entertained and will be treated as unlawful conduct subject to legal action.
                                </p>
                            </div>
                        </div>

                        <div style={{ padding: '0 24px 24px' }}>
                            <button
                                onClick={handleComplianceUnderstand}
                                style={{
                                    width: '100%',
                                    backgroundColor: '#004172',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '8px',
                                    padding: '12px',
                                    fontSize: '15px',
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                }}
                            >
                                I Understand
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div className="flex-1 hidden lg:flex items-center justify-center">
                <img src={loginImage} alt="Login" />
            </div>

            <div className="flex-1 flex flex-col items-center justify-center bg-white">
                <div className="mb-8 text-center">
                    <p className="text-3xl font-medium text-blue-500">
                        Improving Lives Together.
                    </p>
                    <img src={loginDesign} alt="Login Design" />
                </div>

                <div className="w-[32rem] p-8 bg-white rounded shadow-md">
                    <h2 className="text-xl font-bold mb-8">
                        {loginType === 'forget' ? 'Forgot Password' : 'Please Log In'}
                    </h2>

                    {loginType === 'email' && (
                        <>
                            <input
                                name="userCode"
                                placeholder="Enter Email"
                                value={formData.userCode}
                                className="w-full mb-4 p-2 border rounded"
                                onChange={(e) => setFormData({ ...formData, userCode: e.target.value })}
                            />

                            <div className="relative mb-4">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    name="passWord"
                                    placeholder="Enter Password"
                                    value={formData.passWord}
                                    className="w-full p-2 border rounded pr-10"
                                    onChange={(e) => setFormData({ ...formData, passWord: e.target.value })}
                                />
                                <button
                                    type="button"
                                    onClick={togglePasswordVisibility}
                                    className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                                >
                                    {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                </button>
                            </div>

                            <div
                                style={{
                                    backgroundColor: '#f0f7ff',
                                    border: '1px solid #cce0f5',
                                    borderRadius: '8px',
                                    padding: '12px 14px',
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    gap: '10px',
                                    marginBottom: '10px',
                                }}
                            >
                                <span style={{ color: '#004172', fontSize: '18px', marginTop: '1px' }}>🛡️</span>
                                <p style={{ fontSize: '13px', color: '#333', margin: 0, lineHeight: '1.5' }}>
                                    This platform is restricted to human users only. Use of AI systems, bots, or automated software is strictly prohibited.{' '}
                                    <button
                                        type="button"
                                        onClick={() => setShowCompliancePopup(true)}
                                        style={{
                                            background: 'transparent',
                                            border: 'none',
                                            color: '#004172',
                                            fontWeight: 600,
                                            cursor: 'pointer',
                                            padding: 0,
                                            textDecoration: 'underline',
                                            fontSize: '13px',
                                        }}
                                    >
                                        View Compliance →
                                    </button>
                                </p>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', marginBottom: '16px' }}>
                                <input
                                    type="checkbox"
                                    id="humanConfirm"
                                    checked={humanConfirmed}
                                    onChange={(e) => setHumanConfirmed(e.target.checked)}
                                    style={{ marginTop: '3px', cursor: 'pointer', accentColor: '#004172' }}
                                />
                                <label
                                    htmlFor="humanConfirm"
                                    style={{ fontSize: '13px', color: '#333', cursor: 'pointer', lineHeight: '1.5' }}
                                >
                                    <span style={{ color: 'red' }}>*</span> I confirm I am a human user and agree to CureBay's Terms of Service, including the AI &amp; Automation Prohibition Policy
                                </label>
                            </div>

                            <button
                                onClick={handleSubmit}
                                className="w-full bg-blue-500 text-white py-2 rounded mb-3 hover:bg-blue-600 transition-colors disabled:bg-blue-300"
                                disabled={loading || !humanConfirmed}
                                style={{ opacity: !humanConfirmed ? 0.6 : 1, cursor: !humanConfirmed ? 'not-allowed' : 'pointer' }}
                            >
                                {loading ? 'Logging in...' : 'Login'}
                            </button>

                            <div className="flex justify-between items-center">
                                <button
                                    onClick={() => setLoginType('forget')}
                                    className="text-blue-500 hover:underline text-sm"
                                >
                                    Forgot Password?
                                </button>
                            </div>
                        </>
                    )}

                    {loginType === 'forget' && (
                        <>
                            <div className="mb-4">
                                <input
                                    type="email"
                                    placeholder="Enter your email address"
                                    className={`w-full p-2 border rounded ${forgetEmailError ? 'border-red-500' : ''}`}
                                    value={forgetValue}
                                    onChange={handleForgetInputChange}
                                />
                                {forgetEmailError && (
                                    <p className="text-red-500 text-sm mt-1">{forgetEmailError}</p>
                                )}
                            </div>

                            <div className="flex justify-between">
                                <button
                                    onClick={() => {
                                        setLoginType('email');
                                        setForgetEmailError('');
                                        setForgetValue('');
                                    }}
                                    className="text-blue-500 hover:underline"
                                >
                                    Back to Login
                                </button>

                                <button
                                    onClick={handleForgetPassword}
                                    className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                                >
                                    Submit
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default LoginPage;





